import { Color, Vector3 } from 'three';

export const INITIALIZED_SHARED_MATERIAL_UNIFORM = {
  uBoxHalfSizeList: new Vector3(),
  uBoxColorList: new Color(0xffffff),
} as Record<'uBoxColorList' | 'uBoxHalfSizeList', Color | Vector3>;
